const EMAIL_REGEX = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

/**
 * Returns whether a string is a valid email address
 */
export function isValidEmailAddress(address: string): boolean {
	return EMAIL_REGEX.test(address);
}

const E164_US_PHONE_REGEX = /^\+1\d{10}$/;

/**
 * Returns whether a string is a valid E.164 formatted US phone number.
 */
export function isValidE164USPhoneNumber(phone: string): boolean {
	return E164_US_PHONE_REGEX.test(phone);
}
